<div class="container text-center mb-5 mt-4" style="max-width: 40rem;">
  <h1 class="jumbotron-heading text-muted">Something went wrong...</h1>
  <p class="lead text-muted">Sorry! We are encountering technical problems.
    Try again in a few minutes. If the problem repeats itself, please email us at support&#64;qa4sm.eu.</p>
</div>
